import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'

//React Router Dom used to create route paths for the web app
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
// Import Admin Authentication function
import requireAuth from './utils/requireAuth'
// Import Login Authenctication for Regular users
import loginPages from './utils/loginPages'
//Import Footer
import Footer from './components/Footer';
//Import main Views
import EventList from './views/EventList'
import EventManagement from './views/EventManagement'
import ProfilePage from './views/ProfilePage'
import AdminRegister from './views/AdminRegister'
import EventRegister from './views/EventRegister'
import ResetPasswordRequest from './views/ResetPasswordRequest'
import ResetPassword from './views/ResetPassword'
import CreateEmailTemplate from './views/EmailViews/CreateEmailTemplate';
import { emailCreateTemplateLink, emailEditTemplateLink, emailSendEmailLink, emailSentEmailsLink, emailTemplatesLink } from './routeLinks';
import PageNotFound from './views/PageNotFound';
import SentEmailList from './views/EmailViews/SentEmailList';
import EmailTemplateList from './views/EmailViews/EmailTemplateList';
import SendEmail from './views/EmailViews/sendEmail/SendEmailComponent';
import EditEmailTemplate from './views/EmailViews/EditEmailTemplate';
import AGM from './views/AGM/AGM'
import SiteAdmin from './views/SiteAdmin';

const App = props => {
    return (
        <Router>
            <Switch>
                <Route path='/' exact component={loginPages(ProfilePage)} />
                <Route path='/resetpassword' exact component={loginPages(ResetPasswordRequest)} />
                <Route path='/changepassword/:token' exact component={loginPages(ResetPassword)} />
                <Route path='/eventlist' exact component={requireAuth(EventList)} />
                <Route path='/eventmanagement' exact component={requireAuth(EventManagement)} />
                <Route path='/site-admin' exact component={requireAuth(SiteAdmin)} />
                <Route path='/adminregister' exact component={AdminRegister} />
                <Route path='/eventregister' exact component={loginPages(EventRegister)} />
                <Route path='/agm' exact component={loginPages(AGM, false, true)} />
                {/* EMAIL */}
                <Route path={emailCreateTemplateLink} exact component={loginPages(CreateEmailTemplate, true)} />
                <Route path={emailTemplatesLink} exact component={loginPages(EmailTemplateList, true)} />
                <Route path={emailSendEmailLink} exact component={loginPages(SendEmail, true)} />
                <Route path={emailSentEmailsLink} exact component={loginPages(SentEmailList, true)} />
                <Route path={emailEditTemplateLink} exact component={loginPages(EditEmailTemplate, true)} />

                <Route component={PageNotFound} />
            </Switch>
            <Footer />
        </Router>
    );
}

export default App;